import { render } from "./HeroiconsSolidFolder.vue?vue&type=template&id=71572aca"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolder.vue"]])

export default __exports__